module.exports = __webpack_public_path__ + "img/karriere-v5.766bc086.jpg";